import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=5d002305&scoped=true"
import script from "./user-detail.vue?vue&type=script&lang=js"
export * from "./user-detail.vue?vue&type=script&lang=js"
import style0 from "./user-detail.vue?vue&type=style&index=0&id=5d002305&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d002305",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d002305')) {
      api.createRecord('5d002305', component.options)
    } else {
      api.reload('5d002305', component.options)
    }
    module.hot.accept("./user-detail.vue?vue&type=template&id=5d002305&scoped=true", function () {
      api.rerender('5d002305', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/user-detail.vue"
export default component.exports